// Hash-based router. Each screen render function returns an optional cleanup
// callback (e.g., to stop a MediaStream) which the router invokes before
// switching routes. This avoids leaking the camera between screens.

import { renderHome } from './home-screen.js';
import { renderCapture } from './capture-screen.js';
import { renderSettings } from './settings-screen.js';
import { renderJournal } from './journal-screen.js';

const app = () => document.getElementById('app');

let _cleanup = null;

function applyCleanup() {
  if (typeof _cleanup === 'function') {
    try { _cleanup(); } catch (err) { console.warn('Route cleanup failed:', err); }
  }
  _cleanup = null;
}

function setBodyMode(mode) {
  // `data-mode` on <body> lets CSS switch between "shell" and "fullscreen"
  // layouts without re-flowing the whole tree.
  document.body.dataset.mode = mode;
}

function route() {
  applyCleanup();
  const hash = location.hash || '#/';

  if (hash === '#/' || hash === '') {
    setBodyMode('shell');
    _cleanup = renderHome(app()) || null;
    return;
  }
  if (hash.startsWith('#/capture/')) {
    const profile = decodeURIComponent(hash.slice('#/capture/'.length));
    setBodyMode('fullscreen');
    _cleanup = renderCapture(app(), profile) || null;
    return;
  }
  if (hash === '#/settings') {
    setBodyMode('shell');
    _cleanup = renderSettings(app()) || null;
    return;
  }
  if (hash === '#/journal') {
    setBodyMode('shell');
    _cleanup = renderJournal(app()) || null;
    return;
  }

  // Unknown route — fall back to home.
  location.hash = '#/';
}

export function startRouter() {
  window.addEventListener('hashchange', route);
  route();
}

export function navigate(hash) {
  if (location.hash === hash) {
    route(); // force re-render of the same route
  } else {
    location.hash = hash;
  }
}
